import { render, staticRenderFns } from "./GoToFeature.vue?vue&type=template&id=b15fe07e&scoped=true&"
import script from "./GoToFeature.vue?vue&type=script&lang=js&"
export * from "./GoToFeature.vue?vue&type=script&lang=js&"
import style0 from "./GoToFeature.vue?vue&type=style&index=0&id=b15fe07e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15fe07e",
  null
  
)

export default component.exports